export const getClosedWidgetEditState = () => ({
	open: false,
	type: '',
	title: '',
	transparentBackground: false,
	deviceId: 0,
	dataId: 0,
	dataPin: '',
	id: '',
	width: 0,
	height: 0,
	top: 0,
	left: 0,
	props: {},
	showCurves: [],
});
